import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import authService from './authService';

const companyApi = axios.create({
  baseURL: `${API_BASE_URL}/company`,
});

companyApi.interceptors.request.use((config) => {
  const token = authService.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const companyService = {
  getInfo: () => companyApi.get('/info'),
};

export default companyService;

